/**
 * Juicy Pet
 * Collapsible Brand Mega Menu
 *
 * Features:
 * - Only one A-F / G-L / M-R / S-Z section open at once
 * - Resets accordion when Brands mega-menu is closed
 * - Works inside Shopify Theme Editor
 */

(() => {
  const initializeBrandMenus = (root = document) => {
    const brandMenus = root.querySelectorAll('.jp-brand-menu');

    brandMenus.forEach((brandMenu) => {
      if (brandMenu.dataset.jpBrandInitialized === 'true') return;

      brandMenu.dataset.jpBrandInitialized = 'true';

      const accordions = brandMenu.querySelectorAll(
        '.jp-brand-accordion'
      );

      /**
       * Only allow one letter group to be open.
       */
      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', () => {
          if (!accordion.open) return;

          accordions.forEach((otherAccordion) => {
            if (
              otherAccordion !== accordion &&
              otherAccordion.open
            ) {
              otherAccordion.removeAttribute('open');
            }
          });
        });
      });


      /**
       * Reset inner accordions when the main
       * Brands mega-menu closes.
       */
      brandMenu.addEventListener('toggle', () => {
        if (brandMenu.open) return;

        accordions.forEach((accordion) => {
          accordion.removeAttribute('open');
        });
      });
    });
  };


  /**
   * Normal storefront load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeBrandMenus()
    );
  } else {
    initializeBrandMenus();
  }


  /**
   * Shopify Theme Editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeBrandMenus(event.target);
    }
  );
})();
